var map = {
	"./baburao telephone.png": 7631,
	"./baseball ball.png": 8263,
	"./basketball.png": 4887,
	"./boomerang.png": 7212,
	"./bread.png": 9116,
	"./camera.png": 8705,
	"./candy.png": 1367,
	"./chocolate bar.png": 3057,
	"./coffee cup.png": 3179,
	"./colddrink can.png": 4025,
	"./conical empty flask.png": 3040,
	"./conical flask.png": 9321,
	"./diamond.png": 5696,
	"./donut.png": 407,
	"./dumbbells.png": 7745,
	"./flute.png": 3762,
	"./game remote.png": 1507,
	"./hairbrush.png": 6696,
	"./icecream cone.png": 8010,
	"./idea.png": 245,
	"./landline phone.png": 4346,
	"./laptop.png": 6245,
	"./lighting 1.png": 1041,
	"./lighting 2.png": 9388,
	"./lock.png": 8026,
	"./lollipop.png": 54,
	"./magic lock.png": 1010,
	"./magic stick.png": 9145,
	"./mike.png": 4066,
	"./mushroom.png": 9561,
	"./orange icecream bar.png": 989,
	"./round bottom flask.png": 3185,
	"./round diamond.png": 732,
	"./square diamond.png": 3967,
	"./telescope.png": 9092,
	"./torch.png": 2076,
	"./trumpet.png": 9421,
	"./victory cup.png": 4552,
	"./watermelon slice.png": 7458,
	"./wine glass 1.png": 3934,
	"./wine glass 2.png": 4763,
	"./wine glass 3.png": 3390,
	"./writing pad.png": 9824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4415;